import { render, staticRenderFns } from "./ConfirmPublishCourseModal.vue?vue&type=template&id=068bddf1"
import script from "./ConfirmPublishCourseModal.vue?vue&type=script&lang=js"
export * from "./ConfirmPublishCourseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports